import {
  CREATE_UI_COLOR_FONT_REQUEST,CREATE_UI_COLOR_FONT_FAILURE,UPDATE_UI_COLOR_FONT_REQUEST,UPDATE_UI_COLOR_FONT_FAILURE,GET_ALL_UI_COLOR_FONT_REQUEST,GET_ALL_UI_COLOR_FONT_FAILURE,GET_ALL_UI_COLOR_FONT_SUCCESS
} from "./ActionType";

const initialState = {
  uiColorFont: [],
  loading: false,
  error: "",
};

export const uiColorFontReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_UI_COLOR_FONT_REQUEST:
      return { ...state, loading: true };

    case CREATE_UI_COLOR_FONT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case GET_ALL_UI_COLOR_FONT_REQUEST:
      return { ...state, loading: true };

    case GET_ALL_UI_COLOR_FONT_SUCCESS:
      return { ...state, loading: false, error: "", uiColorFont: action.payload };

    case GET_ALL_UI_COLOR_FONT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case UPDATE_UI_COLOR_FONT_REQUEST:
      return { ...state, loading: true };

    case UPDATE_UI_COLOR_FONT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
